import { AxiosResponse } from 'axios';

import api from '~api/api';

export default {
  async getThirdPartyToken(ident: string): Promise<AxiosResponse> {
    return api.post('/v2/redeem/third-party/token', { ident });
  },
  async redeemInShop(
    voucherToken: string,
    redeemValue: number,
    shopId: string,
    customer: object,
    promotion: object,
  ): Promise<AxiosResponse> {
    return api.post(
      '/v2/redeem/voucher-token',
      {
        redeemValue, shopId, customer, promotion,
      },
      {
        headers: {
          'x-jwt-token': voucherToken,
        },
      },
    );
  },
  async getLinkInfo(redeemLinkToken: string): Promise<AxiosResponse> {
    return api.get(`/v2/redeem/link/${redeemLinkToken}`);
  },
  async getMerchantCodes(redeemLinkToken: string): Promise<AxiosResponse> {
    return api.post('/v2/redeem/merchantcode', {
      redeemLinkToken,
    });
  },
  async changeShop(redeemLinkToken: string): Promise<AxiosResponse> {
    return api.post('/v2/redeem/change-shop', {
      redeemLinkToken,
    });
  },
  async resendRedeemLink(code: string): Promise<AxiosResponse> {
    return api.post('/v2/redeem/resend-link', { code });
  },
  async resendRedeemLinkByRedeemLinkToken(redeemLinkToken: string): Promise<AxiosResponse> {
    return api.post('/v2/redeem/resend-link', { redeemLinkToken });
  },
};
